// src/main.js
import {createApp} from 'vue';
import {createPinia} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import router from './router';
import Vant from 'vant';
import 'vant/lib/index.css';
import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import '@/assets/styles/mobile-responsive.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

const app = createApp(App);

// 初始化Pinia（带持久化插件）
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// 注册核心插件
app.use(pinia);
app.use(router);
app.use(Vant);
app.use(LoadingPlugin);
app.mount('#app')
